// 3rd
import Swiper, { Navigation, Scrollbar } from 'swiper';

const paragraphTimeline = [
  ...document.querySelectorAll('.paragraph--timeline'),
];

const initTimeline = () => {
  paragraphTimeline.forEach((timeline) => {
    const container = timeline.querySelector('.swiper-container');

    // eslint-disable-next-line no-new
    new Swiper(container, {
      breakpoints: {
        701: {
          slidesPerView: 2,
          spaceBetween: 23,
        },
      },
      modules: [Navigation, Scrollbar],
      navigation: {
        nextEl: '.navigation-button--next',
        prevEl: '.navigation-button--prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      spaceBetween: 10,
      slidesPerView: 1,
    });
  });
};

(() => {
  if (paragraphTimeline.length > 0) {
    initTimeline();
  }
})();
